/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';
import '../../../vlinder.min.css';
import { useTheme } from '../../../providers/theme';
import {
  PageContainer,
  Logo,
  Heading,
  TermsText,
  SubmitButton,
  GoBackLink,
  FormComp,
  AlertComp,
} from '../components';
import { useRegisterToken } from '../provider';
import { useSMRegisterPageGetContent, useSMRegisterUser } from '../machines/';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { vappContainer } from '@/application';
import { RegisterPageService } from '../services';
import { Loader } from '@/components';

const getSrv = () => {
  return vappContainer.get<RegisterPageService>(
    RegisterPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const { decodedToken, token } = useRegisterToken();
  const theme = useTheme();
  const navigate = useNavigate();
  const staticPageContentConfig = getSrv()?.getStaticPageContent();
  const { registerUserMachine, registerUserSend, registerUserState } =
    useSMRegisterUser({});
  const { registerPageGetContentState } = useSMRegisterPageGetContent({});

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  useEffect(() => {
    if (
      registerUserState.matches('REGISTER_USER_SUCCESS') &&
      registerUserState?.event?.data?.value
    ) {
      toast.success(
        'Registered successfully, please login ' ??
          registerUserState?.event?.data?.value?.status
      );
      setTimeout(() => {
        navigate('/sign-in');
      }, 500);
    }
  }, [
    registerUserState.matches('REGISTER_USER_SUCCESS') &&
      registerUserState?.event?.data?.value,
  ]);

  useEffect(() => {
    if (
      registerUserState.matches('REGISTER_USER_FAILED') &&
      registerUserState?.event?.data?.value
    ) {
      toast.error(registerUserState?.event?.data?.value);
    }
  }, [
    registerUserState.matches('REGISTER_USER_FAILED') &&
      registerUserState?.event?.data?.value,
  ]);

  const onRegisterSubmit = (data: any) => {
    console.log(`register submit`, data);
    registerUserSend('START', {
      payload: {
        email: data?.email,
        firstName: data.firstName,
        lastName: data?.lastName,
        phoneNumber: data?.phoneNumber,
        password: data?.password,
        jwtToken: registerPageGetContentState?.event?.data?.value?.token,
      },
    });
  };
  console.log(`registerPageGetContentState :`, registerPageGetContentState);
  const _getSuccessNotification = () => {};
  const _getErrorNotification = () => {};

  const _getPageContent = () => {
    if (
      registerPageGetContentState?.matches('RENDER_PAGE') &&
      registerPageGetContentState?.event?.data?.value?.initialData
    ) {
      return (
        <>
          <Logo logoURL={staticPageContentConfig?.logo} />
          <GoBackLink />
          <Heading title={staticPageContentConfig?.title} />
          <FormComp
            renderSubmitButton={renderSubmitButton}
            initialData={
              registerPageGetContentState?.event?.data?.value?.initialData || {}
            }
            onFormSubmit={onRegisterSubmit}
            isPasswordField={
              true
              //!!registerPageGetContentState?.event?.data?.value?.isPassword
            }
          />
          <TermsText />
        </>
      );
    }
  };

  if (registerUserState.matches('REGISTER_USER')) {
    return (
      <div style={{ paddingTop: '20px' }}>
        <Loader {...(staticPageContentConfig?.loading?.registerUser || {})} />
      </div>
    );
  } else if (registerPageGetContentState?.matches('GET_PAGE_CONTENT')) {
    return (
      <Loader {...(staticPageContentConfig?.loading?.GetPageLoading || {})} />
    );
  } else {
    return (
      <PageContainer>
        {_getSuccessNotification()}
        {_getErrorNotification()}
        {_getPageContent()}
      </PageContainer>
    );
  }
};
